import api from './request';

const RMS_COMMON_V1 = '/sg/mtop/proretail-pc/api/common/v1';

/**
 * 获取 RMS 环境国家（无入参，同源无跨域）
 */
export function apiGetRmsEnvCountry() {
  return api.post(`${RMS_COMMON_V1}/getRmsEnvCountry`, {
    region: 'sg'
  });
}
